import { api } from './client';
import { notifyNoteChanged } from '../utils/noteChanged';

function saved(storyId, request) {
  return Promise.resolve(request).then((result) => {
    notifyNoteChanged(storyId);
    return result;
  });
}

export const loglineApi = {
  // Basic CRUD endpoints
  get: (storyId) =>
    api.get(`/stories/${storyId}/log-line`),

  update: (storyId, logLine, source) =>
    saved(storyId, api.put(`/stories/${storyId}/log-line`, { log_line: logLine, source })),

  getHistory: (storyId) =>
    api.get(`/stories/${storyId}/log-line/history`),

  restore: (storyId, historyId) =>
    saved(storyId, api.post(`/stories/${storyId}/log-line/restore/${historyId}`)),

  // Workshop endpoints (Phase 2)
  getWorkshop: (storyId) =>
    api.get(`/stories/${storyId}/log-line-workshop`),

  sendWorkshopMessage: (storyId, content) =>
    api.post(`/stories/${storyId}/log-line-workshop/messages`, { content }),

  getWorkshopBookmarks: (storyId) =>
    api.get(`/stories/${storyId}/log-line-workshop/bookmarks`),

  // Generation endpoint (Phase 3)
  generate: (storyId) =>
    api.post(`/stories/${storyId}/log-line/generate`),

  // Get log line suggestions based on story/project context
  getSuggestions: (storyId) =>
    api.post(`/stories/${storyId}/log-line-workshop/suggestions`)
};
